<template>
    <div
        class="home"
        :style="{
            backgroundImage: isWap
                ? 'url(' + wapBgUrl + ')'
                : 'url(' + bgUrl + ')'
        }"
    >
        <script type="speculationrules">
            {
              "prerender": [
                {
                  "urls": ["{{payUrl}}", "{{this.payLink}}"]
                }
              ]
            }
        </script>
        <Nav :pay-url="payUrl"/>
        <!-- 移动端语言选择器 - 显示在页面顶部 -->
        <LanguageSelectorImage
            v-if="isWap"
            :languages="availableLangs"
            :current-language="$i18n.locale"
            :is-mobile="true"
            @language-change="handleLanguageChange"
            class="wap-lang-selector"
            :style="{ top: wapLangSelectorTop }"
        />
        <Cookieconsent />
        <GoModel :pay-url="payUrl" />
        <i class="top" @click="goTop"></i>
        <div class="home-box">
            <a
                class="cash-voucher-btn"
                :style="'background-image:url(' + pupchaseImgUrl + ');'"
                target="_blank"
                :href="payUrl"
                @click="mdataButtonClick('main-topup')"
            ></a>
            <div class="download-btns">
                <a
                    class="apple-btn"
                    :style="'background-image:url(' + appleImgUrl + ');'"
                    :href="appleLink"
                    @click="mdataButtonClick('appstore-download')"
                ></a>
                <a
                    class="google-btn"
                    :style="'background-image:url(' + googleImgUrl + ');'"
                    :href="googleLink"
                    @click="mdataButtonClick('playstore-download')"
                ></a>
                <!-- <a style="visibility: hidden;" class="download-btn" :style="'background-image:url('+ downloadImgUrl +');'" :href="apkLink" @click="mdataButtonClick('apk-download')"></a> -->
            </div>
        </div>
        <div id="dw1"></div>
        <div
            class="content"
            :style="{
                backgroundImage: isWap
                    ? 'url(' + wapContentUrl + ')'
                    : 'url(' + contentUrl + ')'
            }"
        ></div>
        <div id="dw2"></div>
        <div class="imgbox">
            <div
                class="swiper-title"
                :style="{
                    backgroundImage: 'url(' + charactersImgUrl + ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: 'contain'
                }"
            ></div>
            <div class="swiper-container" ref="p5swiper">
                <div class="swiper-wrapper">
                    <div
                        class="swiper-slide"
                        v-for="item in imgsUrl"
                        :key="item.index"
                    >
                        <div
                            class="swiperimg"
                            :style="{
                                'background-image': 'url(' + item.url + ')',
                                'background-size': '100% 100%'
                            }"
                        ></div>
                    </div>
                </div>
            </div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
            <div class="p5swiper-pagination"></div>
        </div>
        <Footer />
    </div>
</template>

<script>
import Swiper from "../utils/swiper4.4.1/swiper.js";
import "../utils/swiper4.4.1/swiper.css";
import { isRTLLocale } from "../utils/rtl.js";
import Nav from "../components/Nav.vue";
import Footer from "../components/Footer.vue";
import Cookieconsent from "../components/Cookieconsent.vue";
import GoModel from "../components/goModel.vue";
import LanguageSelectorImage from "../components/LanguageSelectorImage.vue";
export default {
    name: "HomePage",
    components: {
        Nav,
        Footer,
        GoModel,
        Cookieconsent,
        LanguageSelectorImage
    },
    data() {
        return {
            num: 0,
            demoActive: 0,
            demoTimer: null,
            apkLink: process.env.VUE_APP_DOWNLOAD_LINK,
            payLink: process.env.VUE_APP_PAY_LINK,
            googleLink: process.env.VUE_APP_GOOGLE_LINK,
            appleLink: process.env.VUE_APP_APPLE_LINK,
            baseUrl:
                window.location.protocol +
                "//" +
                window.location.host +
                window.location.pathname,
            availableLangs: [
                { code: "en", name: "English" },
                { code: "pt", name: "Português" },
                { code: "de", name: "Deutsch" },
                { code: "fr", name: "Français" },
                { code: "es", name: "Español" },
                { code: "ar", name: "العربية" },
                { code: "ru", name: "Русский" },
                { code: "zh", name: "简体中文" }
            ]
        };
    },
    computed: {
        payUrl() {
            const { urlParams, cookieAllowed, visitorId } = this.$store.state;
            const query = new URLSearchParams();
            query.set("lang", this.$i18n.locale);
            Object.keys(urlParams).forEach(key => {
                if (urlParams[key]) {
                    query.set(key, urlParams[key]);
                }
            });
            if (!cookieAllowed) {
                query.set("visit_id", visitorId);
            }
            const separator = this.payLink.indexOf("?") !== -1 ? "&" : "?";
            return this.payLink + separator + query.toString();
        },
        bgUrl() {
            return this._getLocaleImage("HomePage", "bg.png");
        },
        wapBgUrl() {
            return this._getLocaleImage("Wap", "bg.png");
        },
        contentUrl() {
            return this._getLocaleImage("HomePage", "content.png");
        },
        wapContentUrl() {
            return this._getLocaleImage("Wap", "content.png");
        },
        imgsUrl() {
            const dir = this.isWap ? "Wap" : "HomePage";
            return [
                { url: this._getLocaleImage(dir, "swiper/pic1.png") },
                { url: this._getLocaleImage(dir, "swiper/pic2.png") },
                { url: this._getLocaleImage(dir, "swiper/pic3.png") }
            ];
        },
        pupchaseImgUrl() {
            return this._getLocaleImage("HomePage", "cash-voucher.png");
        },
        appleImgUrl() {
            const dir = this.isWap ? "Wap" : "HomePage";
            return this._getLocaleImage(dir, "apple.png");
        },
        googleImgUrl() {
            const dir = this.isWap ? "Wap" : "HomePage";
            return this._getLocaleImage(dir, "google.png");
        },
        downloadImgUrl() {
            const dir = this.isWap ? "Wap" : "HomePage";
            return this._getLocaleImage(dir, "download.png");
        },
        charactersImgUrl() {
            const dir = this.isWap ? "Wap" : "HomePage";
            return this._getLocaleImage(dir, "characters.png");
        },
        switchLangStatus() {
            return this.$store.state.isSwitchLangVisible;
        },
        isCookieAllowed() {
            return this.$store.state.cookieAllowed;
        },
        wapLangSelectorTop() {
            return this.$store.state.cookieAllowed ? "2.255rem" : "4.255rem";
        },
        isWap() {
            return this.$store.state.isWap;
        }
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
    },
    methods: {
        _getLocaleImage(moduleDir, fileName) {
            const locale = this.$i18n.locale;
            const fallbackLocale = this.$i18n.fallbackLocale || "en";
            try {
                return require(`../assets/${moduleDir}/${locale}/${fileName}`);
            } catch (e) {
                try {
                    return require(`../assets/${moduleDir}/${fallbackLocale}/${fileName}`);
                } catch (e2) {
                    console.warn(`[i18n-asset] Missing image: ${moduleDir}/${fileName} for locale "${locale}" and fallback "${fallbackLocale}"`);
                    return "";
                }
            }
        },
        handleResize() {
            let rootHtml, deviceWidth;
            rootHtml = document.documentElement;
            deviceWidth = rootHtml.clientWidth;
            if (deviceWidth < 940) {
                this.$store.dispatch("IS_WAP");
            } else {
                this.$store.dispatch("NOT_WAP");
            }
        },
        handleClickOutside(event) {
            //  检查点击事件是否发生在 lang-list 组件或其子元素之外，从而更精确地控制 lang-list 的显示和隐藏。
            if (
                this.$refs.langList &&
                !this.$refs.langList.contains(event.target)
            ) {
                this.closeSwitchLang();
            }
        },
        openSwitchLang() {
            this.$store.dispatch("SHOW_SWITHC_LANG");
        },
        closeSwitchLang() {
            this.$nextTick(() => {
                // this.$nextTick等待DOM更新后再执行
                this.$store.dispatch("HIDE_SWITHC_LANG");
            });
        },
        mdataButtonClick: function (buttonName) {
            this.$store.dispatch("MDATA_CLICK_BUTTON", buttonName);
        },
        handleLanguageChange(langCode) {
            this.$i18n.locale = langCode;
            if (this.$store.state.cookieAllowed) {
                this.setCookie("lang", langCode);
            }
            const params = new URLSearchParams();
            params.set("lang", langCode);
            const urlParams = this.$store.state.urlParams;
            const keys = ['player_token', 'role_id', 'game_code', 'server_id', 'os'];
            keys.forEach(key => {
                if (urlParams[key]) {
                    params.set(key, urlParams[key]);
                }
            });
            window.location.href =
                window.location.protocol +
                "//" +
                window.location.host +
                window.location.pathname +
                "?" +
                params.toString();
        },
        getQueryParam(name) {
            var urlParams = new URLSearchParams(window.location.search);
            return urlParams.get(name);
        },
        setCookie(cookieName, cookieValue) {
            let expires = "";
            const date = new Date();
            date.setTime(
                date.getTime() + this.cookieExpire * 24 * 60 * 60 * 1000
            );
            expires = ";expires=" + date.toUTCString();
            // 设置 cookie，包括名称、值和过期时间
            document.cookie = `${cookieName}=${encodeURIComponent(
                cookieValue
            )}${expires};path=/`;
        },
        getCookie(cookieName) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${cookieName}=`);
            if (parts.length === 2) {
                const cookiePart = parts.pop().split(";").shift();
                return decodeURIComponent(cookiePart);
            }
        },
        initSwiper() {
            const rtl = isRTLLocale(this.$i18n.locale);
            const options = {
                effect: "coverflow",
                slidesPerView: "auto",
                loop: true,
                centeredSlides: true,
                slideToClickedSlide: true,
                autoplayDisableOnInteraction: false,
                allowTouchMove: false,
                autoplay: {
                    delay: 4000
                },
                coverflowEffect: {
                    rotate: 30,
                    stretch: 20,
                    depth: 80,
                    modifier: 1,
                    slideShadows: true
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                },
                pagination: {
                    el: ".p5swiper-pagination",
                    clickable: true
                }
            };
            // RTL 模式下启用 Swiper rtl 配置，使 prev 在右、next 在左，滑动从右向左递进
            if (rtl) {
                options.rtl = true;
            }
            new Swiper(this.$refs.p5swiper, options);
        },
        goTop() {
            window.scroll(0, 0);
        },
        initLang() {
            let lang = this.getQueryParam("lang");
            if (lang === undefined || lang === null || lang === "") {
                lang = this.getCookie("lang");
            }
            if (
                !lang ||
                !Object.prototype.hasOwnProperty.call(this.$i18n.messages, lang)
            ) {
                // 语种不存在
                lang = "en";
            }
            this.$i18n.locale = lang;
            if (this.$store.state.cookieAllowed) {
                this.setCookie("lang", lang);
            }
        }
    },
    mounted() {
        this.$store.dispatch("SAVE_URL_PARAMS");
        setTimeout(() => {
            this.initSwiper();
        }, 100);
        this.$nextTick(() => {
            this.initLang();
        });
        document.addEventListener("click", this.handleClickOutside);
        this.handleResize();
        window.addEventListener("resize", this.handleResize);
    }
};
</script>
<style scoped lang="less">
.cash-voucher-btn {
    animation: homeGlow 2s cubic-bezier(0.36, 0.07, 0.19, 0.97) infinite;
    &:hover {
        animation: none;
        transform: scale(1.1) translateY(-0.04rem);
        filter: drop-shadow(0 0 0.1rem rgba(255, 220, 60, 1))
            drop-shadow(0 0 0.3rem rgba(255, 160, 0, 0.9))
            drop-shadow(0 0 0.5rem rgba(255, 100, 0, 0.5));
    }
}

/* 非移动端隐藏 wap 语言选择器 */
.wap-lang-selector {
    display: none;
}

@keyframes homeGlow {
    0%,
    100% {
        transform: scale(1) translateY(0);
        filter: drop-shadow(0 0 0.06rem rgba(255, 220, 60, 0.3))
            drop-shadow(0 0 0.1rem rgba(255, 160, 0, 0.2));
    }
    40% {
        transform: scale(1.04) translateY(-0.03rem);
        filter: drop-shadow(0 0 0.16rem rgba(255, 220, 60, 1))
            drop-shadow(0 0 0.4rem rgba(255, 160, 0, 0.9))
            drop-shadow(0 0 0.6rem rgba(255, 80, 0, 0.5));
    }
}

@media (min-width: 1920px) {
    .home {
        height: 39.96rem;
        background-repeat: no-repeat;
        background-position: center top;
        width: 100%;
        max-width: 1920px;
        margin: 0 auto;
        //background-size: contain;

        .top {
            position: fixed;
            background: url(../assets/HomePage/top.png) no-repeat center;
            background-size: cover;
            width: 1.2rem;
            height: 1rem;
            right: calc((100vw - 1920px) / 2 + 96px);
            top: 9rem;
            cursor: pointer;
            z-index: 100;
        }

        @media (max-width: 1920px) {
            .top {
                right: 5% !important;
            }
        }
        #dw1 {
            position: absolute;
            left: 10%;
            top: 11.5rem;
            width: 50%;
            height: 1rem;
        }
        .content {
            position: absolute;
            background-repeat: no-repeat;
            //background-size: contain;
            background-position: center;
            width: 100%;
            height: 12.63rem;
            top: 11.5rem;
            left: 0;
            right: 0;
        }
        #dw2 {
            position: absolute;
            top: 22.5rem;
        }
        .imgbox {
            position: absolute;
            top: 25.5rem;
            left: 50%;
            transform: translate(-50%);
            .swiper-title {
                width: 13.97rem;
                height: 0.72rem;
                margin: -1rem auto 0.4rem;
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;
            }
            .swiper-container {
                margin-top: 0.8rem;
                height: 7.5rem;
                width: 14rem;
                .swiper-wrapper {
                    height: 6.5rem;
                    width: 13rem;
                    .swiper-slide {
                        background-size: 100% 100%;
                        height: 5.5rem;
                        width: 7.5rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .swiperimg {
                            display: block;
                            background-size: 100% 100%;
                            width: 8.3rem;
                            height: 5.2rem;
                        }
                    }
                }
            }
            .swiper-button-prev {
                left: -1.1rem;
                top: 50%;
                transform: translateY(-50%);
                width: 0.9rem;
                height: 0.9rem;
                background: url("../assets/HomePage/swiper/left.png");
                background-size: 100% 100%;
                margin-top: 0;
            }
            .swiper-button-next {
                right: -1.1rem;
                top: 50%;
                transform: translateY(-50%);
                width: 0.9rem;
                height: 0.9rem;
                background: url("../assets/HomePage/swiper/right.png");
                background-size: 100% 100%;
                margin-top: 0;
            }
            .p5swiper-pagination {
                position: relative;
                margin-top: -2.2rem;
                text-align: center;
                /deep/ .swiper-pagination-bullet {
                    width: 12px;
                    height: 12px;
                    margin: 0 16px;
                    background: transparent;
                    border: 2px solid #d4af37;
                    opacity: 1;
                    transition: all 0.3s;
                }
                /deep/ .swiper-pagination-bullet-active {
                    background: #f4d03f;
                    border: 2px solid #d4af37;
                    transform: scale(1.2);
                }
            }
        }
    }
    .home-box {
        position: absolute;
        width: 60%;
        left: 20%;
        top: 8.5em;
        height: 2.2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.15rem;
        .cash-voucher-btn {
            background-repeat: no-repeat;
            background-size: cover;
            width: 2.8rem;
            height: 0.8rem;
            background-position: 50% 50%;
            display: block;
        }
        .download-btns {
            display: flex;
            justify-content: center;
            gap: 0.3rem;
        }
        .apple-btn {
            background-repeat: no-repeat;
            background-size: cover;
            width: 1.95rem;
            height: 0.56rem;
        }
        .google-btn {
            background-repeat: no-repeat;
            background-size: cover;
            width: 1.95rem;
            height: 0.56rem;
        }
        .download-btn {
            background-repeat: no-repeat;
            background-size: cover;
            width: 1.95rem;
            height: 0.56rem;
        }
    }
}
@media (min-width: 1440px) and (max-width: 1919px) {
    .home {
        height: 39.96rem;
        background-repeat: no-repeat;
        //background-position: center;
        width: 100%;
        background-size: cover;

        .top {
            position: fixed;
            background: url(../assets/HomePage/top.png) no-repeat center;
            background-size: cover;
            width: 1.2rem;
            height: 1rem;
            right: 5%;
            top: 9rem;
            cursor: pointer;
            z-index: 100;
        }
        .home-box {
            .cash-voucher-btn {
                background-repeat: no-repeat;
                background-size: cover;
                width: 2.8rem;
                height: 0.8rem;
                background-position: 50% 50%;
                display: block;
            }
            .apple-btn {
                background-repeat: no-repeat;
                background-size: cover;
                width: 1.95rem;
                height: 0.56rem;
            }
            .google-btn {
                background-repeat: no-repeat;
                background-size: cover;
                width: 1.95rem;
                height: 0.56rem;
            }
            .download-btn {
                background-repeat: no-repeat;
                background-size: cover;
                width: 1.95rem;
                height: 0.56rem;
            }
        }
        #dw1 {
            position: absolute;
            left: 10%;
            top: 11.5rem;
            width: 50%;
            height: 1rem;
        }
        .content {
            position: absolute;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            width: 100%;
            height: 12.63rem;
            top: 11.5rem;
            left: 0;
            right: 0;
        }
        #dw2 {
            position: absolute;
            top: 22.5rem;
        }
        .imgbox {
            position: absolute;
            top: 26.5rem;
            left: 50%;
            transform: translate(-50%);
            .swiper-title {
                width: 13.97rem;
                height: 0.72rem;
                margin: -2rem auto 0.4rem;
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;
            }
            .swiper-container {
                margin-top: 0.8rem;
                height: 7.5rem;
                width: 14rem;
                .swiper-wrapper {
                    height: 6.5rem;
                    width: 13rem;
                    .swiper-slide {
                        background-size: 100% 100%;
                        height: 5.5rem;
                        width: 7.5rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .swiperimg {
                            display: block;
                            background-size: 100% 100%;
                            width: 8.3rem;
                            height: 5.2rem;
                        }
                    }
                }
            }
            .swiper-button-prev {
                left: -1.1rem;
                top: 50%;
                transform: translateY(-50%);
                width: 0.9rem;
                height: 0.9rem;
                background: url("../assets/HomePage/swiper/left.png");
                background-size: 100% 100%;
                margin-top: 0;
            }
            .swiper-button-next {
                right: -1.1rem;
                top: 50%;
                transform: translateY(-50%);
                width: 0.9rem;
                height: 0.9rem;
                background: url("../assets/HomePage/swiper/right.png");
                background-size: 100% 100%;
                margin-top: 0;
            }
            .p5swiper-pagination {
                position: relative;
                margin-top: -2.2rem;
                text-align: center;
                /deep/ .swiper-pagination-bullet {
                    width: 12px;
                    height: 12px;
                    margin: 0 16px;
                    background: transparent;
                    border: 2px solid #d4af37;
                    opacity: 1;
                    transition: all 0.3s;
                }
                /deep/ .swiper-pagination-bullet-active {
                    background: #f4d03f;
                    border: 2px solid #d4af37;
                    transform: scale(1.2);
                }
            }
        }
    }
    .home-box {
        position: absolute;
        width: 80%;
        left: 10%;
        top: 8.5rem;
        height: 2.2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.15rem;
        .download-btns {
            display: flex;
            justify-content: center;
            gap: 0.3rem;
        }
    }
}
@media (min-width: 940px) and (max-width: 1439px) {
    html body #app {
        width: 100%;
    }
    body {
        margin: 0;
        padding: 0;
    }
    .home {
        height: 39.96rem;
        background-repeat: no-repeat;
        background-position: center;
        width: 100%;
        background-size: cover;

        .top {
            position: fixed;
            background: url(../assets/HomePage/top.png) no-repeat center;
            background-size: cover;
            width: 1.2rem;
            height: 1rem;
            right: 5%;
            top: 9rem;
            cursor: pointer;
            z-index: 100;
        }
        .home-box {
            .cash-voucher-btn {
                background-repeat: no-repeat;
                background-size: cover;
                width: 2.8rem;
                height: 0.8rem;
                background-position: 50% 50%;
                display: block;
            }
            .apple-btn {
                background-repeat: no-repeat;
                background-size: cover;
                width: 1.95rem;
                height: 0.56rem;
            }
            .google-btn {
                background-repeat: no-repeat;
                background-size: cover;
                width: 1.95rem;
                height: 0.56rem;
            }
            .download-btn {
                background-repeat: no-repeat;
                background-size: cover;
                width: 1.95rem;
                height: 0.56rem;
            }
        }
        #dw1 {
            position: absolute;
            left: 10%;
            top: 11.5rem;
            width: 50%;
            height: 1rem;
        }
        .content {
            position: absolute;
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;
            width: 100%;
            height: 12.63rem;
            top: 11.2rem;
            left: 0;
            right: 0;
        }
        #dw2 {
            position: absolute;
            top: 22.5rem;
        }
        .imgbox {
            position: absolute;
            top: 24.5rem;
            left: 50%;
            transform: translate(-50%);
            .swiper-title {
                width: 13.97rem;
                height: 0.72rem;
                margin: -1.5rem auto 0.3rem;
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;
            }
            .swiper-container {
                margin-top: 0.8rem;
                height: 7.5rem;
                width: 10rem;
                .swiper-wrapper {
                    height: 6.5rem;
                    width: 10rem;
                    .swiper-slide {
                        background-size: 100% 100%;
                        height: 5.5rem;
                        width: 7.5rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .swiperimg {
                            display: block;
                            background-size: 100% 100%;
                            width: 8.3rem;
                            height: 5.2rem;
                        }
                    }
                }
            }
            .swiper-button-prev {
                display: none;
            }
            .swiper-button-next {
                display: none;
            }
            .p5swiper-pagination {
                position: relative;
                margin-top: -2.2rem;
                text-align: center;
                /deep/ .swiper-pagination-bullet {
                    width: 10px;
                    height: 10px;
                    margin: 0 15px;
                    background: transparent;
                    border: 2px solid #d4af37;
                    opacity: 1;
                    transition: all 0.3s;
                }
                /deep/ .swiper-pagination-bullet-active {
                    background: #f4d03f;
                    border: 2px solid #d4af37;
                    transform: scale(1.2);
                }
            }
        }
    }
    .home-box {
        position: absolute;
        width: 80%;
        left: 10%;
        top: 8.5rem;
        height: 1.3rem;
        display: flex;
        justify-content: space-around;
    }
}
@media (max-width: 939px) {
    .wap-lang-selector {
        position: fixed;
        right: 0.4rem;
        z-index: 998;
        transform: scale(0.5);
        transform-origin: top right;
        display: block;
    }
    html body #app {
        width: 100%;
    }
    .home {
        height: 29.97rem;
        background-repeat: no-repeat;
        background-position: center top;
        width: 100%;
        background-size: cover;

        .top {
            display: none; /* WAP 模式下隐藏返回顶部按钮 */
        }
        .home-box {
            position: absolute;
            width: 85%;
            left: 50%;
            transform: translateX(-50%);
            top: 7rem;
            height: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 0.2rem;

            .cash-voucher-btn {
                background-repeat: no-repeat;
                background-size: cover;
                width: 2.5rem;
                height: 0.72rem;
                background-position: 50% 50%;
                display: block;
            }
            .download-btns {
                display: flex;
                justify-content: center;
                gap: 0.2rem;
            }
            .apple-btn {
                background-repeat: no-repeat;
                background-size: cover;
                width: 1.95rem;
                height: 0.56rem;
            }
            .google-btn {
                background-repeat: no-repeat;
                background-size: cover;
                width: 1.95rem;
                height: 0.56rem;
            }
            .download-btn {
                margin-top: 0.15rem;
                background-repeat: no-repeat;
                background-size: cover;
                width: 1.95rem;
                height: 0.56rem;
            }
        }
        #dw1 {
            position: absolute;
            top: 9rem;
            left: 0;
            width: 100%;
            height: 1px;
        }
        .content {
            position: absolute;
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center top;
            width: 100%;
            height: 11.82rem;
            left: 0;
            right: 0;
            margin: 0 auto;
            top: 9rem;
        }
        #dw2 {
            position: absolute;
            top: 20.5rem;
            left: 0;
            width: 100%;
            height: 1px;
        }
        .imgbox {
            position: absolute;
            top: 21rem;
            left: 50%;
            transform: translate(-50%);
            width: 100%;
            .swiper-title {
                width: 7.5rem;
                height: 0.5rem;
                margin: 0.7rem auto 0.5rem;
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;
            }
            .swiper-container {
                margin-top: 1rem;
                height: 6.5rem;
                margin-left: auto;
                margin-right: auto;
                .swiper-wrapper {
                    height: 6.25rem;
                    width: 8.3rem;
                    .swiper-slide {
                        background-size: 100% 100%;
                        height: 3.43rem;
                        width: 70vw;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .swiperimg {
                            display: block;
                            background-size: 100% 100%;
                            width: 5.44rem;
                            height: 3.43rem;
                        }
                    }
                }
            }
            .swiper-button-prev {
                top: 50%;
                left: 0.4rem;
                transform: translateY(-50%);
                width: 0.6rem;
                height: 0.6rem;
                background: url("../assets/HomePage/swiper/left.png");
                background-size: 100% 100%;
                margin-top: 0.3rem;
            }
            .swiper-button-next {
                top: 50%;
                right: 0.4rem;
                transform: translateY(-50%);
                width: 0.6rem;
                height: 0.6rem;
                background: url("../assets/HomePage/swiper/right.png");
                background-size: 100% 100%;
                margin-top: 0.3rem;
            }
            .p5swiper-pagination {
                position: relative;
                margin-top: -3.5rem;
                text-align: center;
                /deep/ .swiper-pagination-bullet {
                    width: 8px;
                    height: 8px;
                    margin: 0 15px;
                    background: transparent;
                    border: 2px solid #d4af37;
                    opacity: 1;
                    transition: all 0.3s;
                }
                /deep/ .swiper-pagination-bullet-active {
                    background: #f4d03f;
                    border: 2px solid #d4af37;
                    transform: scale(1.3);
                }
            }
        }
    }
}
</style>
